import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Box,
    Button,
    MenuItem,
    SelectChangeEvent,
    Select,
    Tabs,
    Tab,
    IconButton,
    TextField,
} from "@mui/material";
import "react-phone-input-2/lib/bootstrap.css";
import SearchBar from "../../components/SearchBar";
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}
interface LoyaltyRow {
    id: number;
    customerName: string;
    email: string;
    phone: string;
    loyaltyUsage: number;
    loyaltyBalance: number;
}

// Dummy data
const initialRows: LoyaltyRow[] = [
    {
        id: 1,
        customerName: "Madelyn Dias",
        email: "madelyndias@gmail.com",
        phone: "+91 9876543210",
        loyaltyUsage: 120,
        loyaltyBalance: 480,
    },
    {
        id: 2,
        customerName: "John Smith",
        email: "johnsmith@gmail.com",
        phone: "+91 9123456780",
        loyaltyUsage: 200,
        loyaltyBalance: 300,
    },
];

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}
const LoyaltyPoints = () => {
    const [rows] = useState<LoyaltyRow[]>(initialRows);

    const [searchTerm, setSearchTerm] = useState("");
    const [valueTabs, setValueTabs] = React.useState(0);
    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabs(newValue);
    };
    const navigate = useNavigate();

    const [selectField1, setSelectField1] = React.useState('default');
    const handleChange1 = (event: SelectChangeEvent) => {
        setSelectField1(event.target.value as string);
    };

    return (
        <>
            <div className="main_title">
                <h1>Loyalty & Promotions</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button>
                    {' '} - Loyalty & Promotions
                </p>
            </div>

            <div className="table_header">
                <div className="left_s">
                    <Box className="custom_tabs1" sx={{ width: "100%" }}>
                        <Tabs
                            value={valueTabs}
                            onChange={handleChangeTabs}
                            aria-label="basic tabs example"
                            className="custom_tabs_links"
                        >
                            <Tab label="Loyalty Settings" {...a11yProps(0)} />
                            <Tab label="Top Customers" {...a11yProps(1)} />
                        </Tabs>
                    </Box>

                </div>
            </div>
            <div className="cards">
                <CustomTabPanel value={valueTabs} index={0}>
                    <div className="form">
                        <div className="gap_p">
                            <div className="control_group w_33">
                                <label htmlFor="currencyAmount">Currency Amount</label>
                                <TextField
                                    id="currencyAmount"
                                    placeholder="Enter Amount"
                                    hiddenLabel
                                    fullWidth
                                />
                            </div>

                            <div className="control_group w_33">
                                <label htmlFor="pointsPerCurrency">Points per Currency Amount</label>
                                <TextField
                                    id="pointsPerCurrency"
                                    placeholder="Enter points per unit"
                                    hiddenLabel
                                    fullWidth
                                />
                            </div>

                            <div className="control_group w_33">
                                <label htmlFor="maxUsage">Max % usage per booking</label>
                                <TextField
                                    id="maxUsage"
                                    placeholder="Enter max percentage"
                                    hiddenLabel
                                    fullWidth
                                />
                            </div>

                            <div className="control_group w_33">
                                <label htmlFor="minBalance">Min balance to redeem</label>
                                <TextField
                                    id="minBalance"
                                    placeholder="Enter minimum balance"
                                    hiddenLabel
                                    fullWidth
                                />
                            </div>

                            <div className="control_group w_33">
                                <label htmlFor="expiryDuration">Expiry Duration (e.g., 12 months)</label>
                                <TextField
                                    id="expiryDuration"
                                    placeholder="Enter expiry duration"
                                    hiddenLabel
                                    fullWidth
                                />
                            </div>
                        </div>

                        <div className="form_btn">
                            <Button className="btn btn_primary">Save</Button>
                        </div>
                    </div>


                </CustomTabPanel>
                <CustomTabPanel value={valueTabs} index={1}>
                    <div className="table_header">
                        <div className="left_s">
                            <Box className="search_box">
                                <SearchBar
                                    searchTerm={searchTerm}
                                    setDebouncedSearchTerm={setSearchTerm}
                                    placeholder="Search..."
                                />
                            </Box>
                        </div>
                        <div className="right_s">
                            <p>Total Points Issued/Redeemed : <strong>2500</strong></p>
                        </div>
                    </div>
                    <TableContainer className="table_container">
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Sr. No.</TableCell>
                                    <TableCell>User Details</TableCell>
                                    <TableCell>Loyalty Usage (In Points)</TableCell>
                                    <TableCell>Loyalty Balance</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {rows
                                    .filter((row) =>
                                        row.customerName.toLowerCase().includes(searchTerm.toLowerCase())
                                    )
                                    .map((row, index) => (
                                        <TableRow hover key={row.id}>
                                            {/* Sr. No. */}
                                            <TableCell>{index + 1}</TableCell>

                                            {/* User Details */}
                                            <TableCell>
                                                <div className="user_block">
                                                    <figure>
                                                        <img src="/static/images/user_placeholder.png" alt="User" />
                                                    </figure>
                                                    <p>
                                                        <b>{row.customerName}</b>
                                                        <span>{row.email || "user@example.com"}</span>
                                                        <span>{row.phone || "+91 9876543210"}</span>
                                                    </p>
                                                </div>
                                            </TableCell>

                                            {/* Loyalty Usage */}
                                            <TableCell>{row.loyaltyUsage || 0}</TableCell>

                                            {/* Loyalty Balance */}
                                            <TableCell>{row.loyaltyBalance || 0}</TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                </CustomTabPanel>
            </div>
        </>
    );
};

export default LoyaltyPoints;
